import { createSelector } from 'reselect';
import type { StoreState } from '@common/types/store';
import type { IntegrationFunctionsState } from '../reducers/integration-functions';
import type { FunctionGroup } from '../actions/integration-functions';

const getIntegrationFunctionsState = (state: StoreState): IntegrationFunctionsState => state.admin.integrationFunctions || {
    loading: false,
    error: null,
    data: [] as FunctionGroup[],
    syncing: false,
    syncError: null
  };

export const getIntegrationFunctions = createSelector(
  [getIntegrationFunctionsState],
  (integrationFunctions) => integrationFunctions.data,
);

export const getIntegrationFunctionsLoading = createSelector(
  [getIntegrationFunctionsState],
  (integrationFunctions) => integrationFunctions.loading,
);

export const getIntegrationFunctionsError = createSelector(
  [getIntegrationFunctionsState],
  (integrationFunctions) => integrationFunctions.error,
);

export const getAllFunctions = createSelector(
  [getIntegrationFunctions],
  (functionGroups) => {
    const allFunctions = new Map();

    functionGroups.forEach((group) => {
      group.linked_with.forEach((func) => {
        if (!allFunctions.has(func.id)) {
          allFunctions.set(func.id, {
            id: func.id,
            name: func.name,
          });
        }
      });
    });

    return Array.from(allFunctions.values());
  },
);

export const getIntegrationSyncing = createSelector(
  [getIntegrationFunctionsState],
  (integrationFunctions) => integrationFunctions.syncing,
);

export const getIntegrationSyncError = createSelector(
  [getIntegrationFunctionsState],
  (integrationFunctions) => integrationFunctions.syncError,
);

export const getUnlinkedFunctions = createSelector(
  [getIntegrationFunctions],
  (functionGroups) => {
    return functionGroups.filter((group) => !group.linked_with || group.linked_with.length === 0
    );
  },
);
